import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { BORDER_RADIUS, semanticColors } from '@/theme/tokens';
import { CONTROL_HEIGHT } from './settingsStyles';

// The theme's `primary` is a pale highlight blue, so the actions set their own
// colors to match the settings Save buttons.
const ACTION_SX = {
  textTransform: 'none',
  fontSize: '13px',
  fontWeight: 600,
  height: CONTROL_HEIGHT.dialog,
  px: 2,
  borderRadius: BORDER_RADIUS,
  boxShadow: 'none',
  '&:focus-visible': {
    outline: `2px solid ${semanticColors.brandPrimary}`,
    outlineOffset: '2px',
  },
} as const;

export default function SettingsDiscardDialog({
  open,
  busy,
  onKeep,
  onDiscard,
}: {
  open: boolean;
  busy: boolean;
  onKeep: () => void;
  onDiscard: () => void;
}) {
  const { t } = useTranslation('settings');
  return (
    <Dialog
      open={open}
      onClose={onKeep}
      maxWidth="xs"
      fullWidth
      aria-labelledby="settings-discard-title"
      aria-describedby="settings-discard-description"
    >
      <DialogTitle id="settings-discard-title">{t('unsavedTitle')}</DialogTitle>
      <DialogContent>
        <DialogContentText id="settings-discard-description">
          {t('unsavedDescription')}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button
          onClick={onDiscard}
          disabled={busy}
          sx={{
            ...ACTION_SX,
            // #dc2626 keeps the label at 4.8:1 on white; `danger` is 3.8:1.
            color: semanticColors.dangerHover,
            '&:hover': { backgroundColor: semanticColors.overlaySubtle },
          }}
        >
          {t('discardChanges')}
        </Button>
        <Button
          onClick={onKeep}
          autoFocus
          variant="contained"
          disableElevation
          sx={{
            ...ACTION_SX,
            backgroundColor: semanticColors.textPrimary,
            color: semanticColors.textOnPrimary,
            '&:hover': { backgroundColor: semanticColors.brandAccent, boxShadow: 'none' },
          }}
        >
          {t('keepEditing')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
